import React from 'react';
import Checkout from './checkout';

function CheckoutIndex({ cartList, onSubmit, giftCard }) {
  return <Checkout cartList={cartList} onSubmit={onSubmit} giftCard={giftCard} />;
}

export default CheckoutIndex;
